import React from 'react';
import { useChatStore } from 'stores/chat';
import Modal from 'components/Modal/Modal';
import Button from 'components/Button/Button';
import PropTypes, { string } from 'prop-types';
import { text } from 'polyglot/polyglot';

import styles from './PrivateChatUserBlockModal.module.scss';

const removePrivateChatUserBlockModalMsgSelector = (state) =>
  state.removePrivateChatUserBlockModalMsg;

function PrivateChatUserBlockModal({ blockMsg }) {
  const removePrivateChatUserBlockModalMsg = useChatStore(
    removePrivateChatUserBlockModalMsgSelector
  );
  const closeModal = () => {
    removePrivateChatUserBlockModalMsg(blockMsg);
  };

  const blocked =
    blockMsg.action === 'block' || blockMsg.action === 'blockrequest';

  const modalButtons = [
    <Button
      key="cancel-button"
      className={styles.button}
      onClick={() => closeModal()}
      isSecondary
    >
      {text.t('chat.modal.okButton')}
    </Button>,
  ];

  return (
    <Modal
      title={
        blocked
          ? text.t('chat.modal.chatUserBlock.blocked.title')
          : text.t('chat.modal.chatUserBlock.unblocked.title')
      }
      content={
        <div className={styles.reqText}>
          <p className={styles.reqUser}>{blockMsg.userName}</p>

          {blocked ? (
            <p>{text.t('chat.modal.chatUserBlock.blocked.text')}</p>
          ) : (
            <p>{text.t('chat.modal.chatUserBlock.unblocked.text')}</p>
          )}

          {blockMsg.action === 'blockrequest' ? (
            <p>
              {text.t('chat.modal.chatUserBlock.blocked.blockrequestText', {
                name: blockMsg.userName,
              })}
            </p>
          ) : null}
        </div>
      }
      buttons={modalButtons}
      className={styles.reqModal}
    />
  );
}

PrivateChatUserBlockModal.propTypes = {
  blockMsg: PropTypes.shape({
    userName: string.isRequired,
    action: string.isRequired,
  }).isRequired,
};

export default PrivateChatUserBlockModal;
